// var slider = document.getElementById('slider-range');

// noUiSlider.create(slider, {
//     start: [10, 80],
//     connect: true,
//     range: {
//         'min': 0,
//         'max': 4000
//     }
// });


/*
  Где нужно в html вставляешь дабл ренж
  <div id="slider"></div>
*/
// находишь свой дабл ренж
const slider = document.getElementById("slider-range");
//задаёшь minPrice, maxPrice
let minPrice = 0;
let maxPrice = 300;
// Подключи библиотеку к элементу
noUiSlider.create(slider, {
  start: [minPrice, maxPrice],
  connect: true,
  step: 10,
  range: {
    min: minPrice,
    max: maxPrice,
  },
});
// Вызываешь функцию изменения minPrice и maxPricef
function loadRange() {
  setTimeout(() => {
    slider.noUiSlider.on("update", event => {
      minPrice = event[0];
      maxPrice = event[1];
      //здесь же можно изменить value числового input
    //   inputMinPrice.value = Number(event[0]).toFixed(0);
    //   inputMaxPrice.value = Number(event[1]).toFixed(0);
    });
    // Вызываешь функцию ,которая срабатывает, когда ты отпускаешь ползунок
    // она же будет менять url
    slider.noUiSlider.on("end", event => {
      const queryParam = `?filter.v.price.gte=${minPrice}&filter.v.price.lte=${maxPrice}&`;
      // добавляешь строку параметров в текущий url
      const currHost = window.location.host;
      const currPath = window.location.pathname;
      //добавляешь фильтрацию в текущий url. Эта строка обнуляет всю фильтрацию и устанавливает только цены. хочешь поддержку уже добавленых фильтров - можешь заморочиться
      window.location.assign(`${currPath}${queryParam}`);
    });
  }, 2000)  
}

loadRange()









